module.exports = __webpack_public_path__ + "img/logo-dgh.e2495efe.png";